import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { IApiLanguages, IApiLessons, IApiProfLevels, IApiVocabularies, IUser, LoginPayload } from "@vokab/shared/src/types";
import {VocabularyQueryParams} from '@vokab/shared/src/types'
// ategoryId=4e2f8308-f0fb-4419-8d08-1c48c66f43d4&categoryName=Introduction&lessonId=16f7d5e9-267d-47bf-ab13-97feda27634c&sourceLanguage=English&targetLanguage=Tamil&profLevel=Level%201&lessonName=Lesson%202




// Define a service using a base URL and expected endpoints
 const api = createApi({
	reducerPath: "api",
	extractRehydrationInfo: (state) => state.api,
	keepUnusedDataFor: 60 * 60 * 1000, // 1 hour
	baseQuery: fetchBaseQuery({ baseUrl: "/api" }),
	refetchOnReconnect: true,
	refetchOnMountOrArgChange: false,
	tagTypes: ["User"],
	endpoints: (builder) => ({
		loginByUsernamePassword: builder.mutation<IUser, LoginPayload>({
			query: (payload) => ({
				method: "POST",
				url: "auth/login",
				body: payload,
			}),
		}),
		getAllProficiencyLevels: builder.query<IApiProfLevels, void>({
			query: () => ({
				method: "GET",
				url: "common/prof-levels",
			}),
		}),
		getAllLessons: builder.query<IApiLessons, void>({
			query: (payload) => ({
				method: "GET",
				url: "common/lessons",
			}),
		}),
		getAllLanguages: builder.query<IApiLanguages, void>({
			query: () => ({
				method: "GET",
				url: "common/languages",
			})
		}),
		getAllVocabularies: builder.mutation<IApiVocabularies, VocabularyQueryParams>({
			query: ({headers,...args}) => {
				const params=new URLSearchParams(args).toString();
				return(
					{
						method: "GET",
						url: `common/vocabularies?${params}`,
					}
				)
			}
		}),
		
	}),
});
export default api


// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
